// extracted by mini-css-extract-plugin
export default {"userWrap":"User_userWrap__sevpb","userName":"User_userName__JdiSF","listWrap":"User_listWrap__GvujD","ul":"User_ul__tn5O2"};